import { render } from "./TutorialPageHighlights.vue?vue&type=template&id=04daab24&scoped=true"
import script from "./TutorialPageHighlights.vue?vue&type=script&lang=js"
export * from "./TutorialPageHighlights.vue?vue&type=script&lang=js"

import "./TutorialPageHighlights.vue?vue&type=style&index=0&id=04daab24&scoped=true&lang=css"
import "./TutorialPageHighlights.vue?vue&type=style&index=1&id=04daab24&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04daab24"]])

export default __exports__